"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agentSchema = exports.agencySchema = void 0;
var agentSchema = (props, pageUrl) => {
  return {
    '@context': 'http://schema.org/',
    '@type': 'Person',
    name: props.name.replace(/"/g, ''),
    url: pageUrl,
    image: props.photo,
    telephone: props.phone,
    description: props.bio.replace(/<\/?[^>]+(>|$)/g, ''),
    jobTitle: props.agentTitle,
    worksFor: {
      '@type': 'Organization',
      name: 'MassMutual'
    },
    workLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: props.location.city + ', ' + props.location.state,
        postalCode: props.location.zip,
        streetAddress: props.location.addressLine + props.location.addressLinesExtra
      }
    }
  };
};
exports.agentSchema = agentSchema;
var agencySchema = (props, pageUrl) => {
  return {
    '@context': 'http://schema.org',
    '@type': 'localBusiness',
    name: props.name,
    url: pageUrl,
    telephone: props.phone,
    parentOrganization: {
      '@type': 'Organization',
      name: 'MassMutual'
    },
    employee: {
      '@type': 'Person',
      name: props.agentList
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: props.location.city + ', ' + props.location.state,
      postalCode: props.location.zip,
      streetAddress: props.location.addressLine + props.location.addressLinesExtra
    },
    location: {
      '@type': 'Place',
      hasmap: {
        '@type': 'Map',
        url: props.mapLink
      }
    }
  };
};
exports.agencySchema = agencySchema;